<template>
  <div class="home">
    <div class="navbar-fixed-container">
      <Navbar :copy="false" :showProModalFn="showProModal" />
      <div class="cookies" v-if="!cookies">
      <div class="col-md-12 cookie-text">
        {{ $t("cookies") }}
        <span class="privacy-link" @click="privacy">{{ $t("privacy") }}</span
        ><br />
        <span class="pull-right">
          <button class="btn btn-accept btn-sm" @click="accept">
            {{ $t("accept") }}
          </button>
          <button class="btn btn-policy btn-sm" @click="decline">
            {{ $t("decline") }}
          </button>
        </span>
      </div>
    </div>

    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3 area">
          <div class="card text-center">
            <div class="card-header">
              <img src="../../public/logo.png" width="30%" alt="" />
            </div>
            <div class="card-body">
              <b-alert v-if="message != null" show dismissible variant="danger">
                {{ message }}
              </b-alert>
              <input
                :placeholder="$t('phTitle')"
                type="text"
                @keyup.enter="listPage"
                class="form-control text-center"
                v-model="title"
              />
              <button
                class="btn btn-info createB mt-3"
                @click="listPage"
                id="createList"
              >
                {{ $t("create") }}
              </button>
            </div>
          </div>
          <div class="card mt-4 p-3">
            <div class="row align-items-start">
              <div class="col-8">
                <p class="font-weight-light align-baseline mb-0">
                  {{ $t('pro.moreFeatures') }}
                  <img src="../../public/logo_pro.png" alt="List2Go Pro" class="pro-logo show-screen" />
                  <span class="show-mobile pro-text">List2Go<span class="pro-suffix">Pro</span></span>
                </p>
                <p
                  style="font-size: 0.7rem; overflow: visible"
                  class="text-muted mt-0"
                >
                  {{ $t('pro.forTeachers') }}
                </p>
              </div>
              <div class="col-4 p-0">
                <div class="d-flex justify-content-end pr-3">
                  <button
                    type="button"
                    class="btn btn-light btn-sm font-weight-bold pro-button"
                    @click="showProModal"
                  >
                    {{ $t('pro.learnMore') }}
                  </button>
                </div>
              </div>
            </div>
            <ul
              class="list-unstyled text-left text-small"
              style="font-size: 0.8rem"
            >
              <li>🔒 {{ $t('pro.security') }}</li>
              <li>🔄 {{ $t('pro.recovery') }}</li>
              <li>👁️ {{ $t('pro.dashboard') }}</li>
              <li>⚙️ {{ $t('pro.andMore') }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="button-div mb-3 ml-3" id="goleft">
      <div class="mb-1 ml-1 font-weight-bold">
        {{ $t("rL") }}
      </div>
      <div>
        <a href="https://readt.app" target="_blank">
          <button
            type="button"
            id="readt"
            class="btn btn-dark font-weight-bold"
          >
            {{ $t("mI") }}
          </button>
        </a>
      </div>
    </div>

    <div class="mb-2 mb-lg-3 mb-xl-3 mr-4 toFaq">
      <img
        src="../../public/question-circle-regular.svg"
        alt="Button to FAQ"
        @click="goup"
      />
    </div>

    <footer class="footer" id="footer-text">
      <div class="container mx-2">
        <div class="row row-close">
          <button
            type="button"
            class="close"
            @click="closeFooter"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <span id="dynamicFooter" v-html="$t('moreInfo')"></span>
      </div>
      <div class="row justify-content-center mx-0" id="social">
        <a href="https://www.instagram.com/list2go.io/" target="_blank"
          ><img
            class="icon-social mb-1"
            src="../../public/instagram-brands.svg"
            alt="Button to Instagram"
        /></a>
        <a href="https://twitter.com/list2g" target="_blank"
          ><img
            class="icon-social mb-1"
            src="../../public/twitter-square-brands.svg"
            alt="Button to Twitter"
        /></a>
      </div>
    </footer>
    <ProModal ref="proModal" />
  </div>
</template>

<script>
import ProModal from "../components/ProModal";
import Navbar from "../components/Navbar";
import { mapActions, mapGetters } from "vuex";
export default {
	name: "Home",
	components: {
		Navbar,
		ProModal,
	},
	computed: {
		...mapGetters(["newList"]),
	},
	data() {
		return {
			title: null,
			message: null,
			cookies: false,
		};
	},
	methods: {
		...mapActions(["createList"]),
		privacy() {
			const currentPath = this.$route.path; // Get the current route path
			const currentLocale = this.$i18n.locale; // Get the current locale

			// Check if the current path ends with the locale
			// For example, check if the path is '/en' or '/de' or '/fr'
			if (currentPath.endsWith("/" + currentLocale)) {
				// Construct the navigation path without the locale prefix
				const privacyPath = currentPath + "/privacy-policy";
				this.$router.push({ path: privacyPath });
			} else {
				// Default case for other routes
				this.$router.push({ path: `/${currentLocale}/privacy-policy` });
			}
		},
		listPage() {
			if (this.title != null && this.title.length > 1) {
				const payload = {
					title: this.title,
				};
				this.createList(payload);
			} else {
				this.message = this.$t("unvalidList");
			}
		},
		goup() {
			document.getElementById("footer-text").style.bottom = "0px";
			document.getElementById("goleft").style.left = "-20rem";
		},
		closeFooter() {
			document.getElementById("footer-text").style.bottom = "-45rem";
			document.getElementById("goleft").style.left = "0rem";
		},
		getCookie(name) {
			var cookieArr = document.cookie.split(";");

			for (var i = 0; i < cookieArr.length; i++) {
				var cookiePair = cookieArr[i].split("=");

				if (name == cookiePair[0].trim()) {
					this.cookies = true;
					return decodeURIComponent(cookiePair[1]);
				}
			}
			// Return null if not found
			return null;
		},
		accept() {
			var cookie = "acceptCookie" + "=" + encodeURIComponent("acceptCookie");

			cookie += "; max-age=" + 365 * 24 * 60 * 60;

			document.cookie = cookie;
			this.cookies = true;

			// Call the GTM initialization function when the button is clicked
			initializeGTM();
		},
		showProModal() {
			this.$refs.proModal.proModal = true;
		},
    
		decline() {
			const measurementId = "G-S4V17ZZQRE";
			const apiSecret = "FfYe-ocHRJ2ZSM-kA0Bi2g";

			// Greate a completley random and anonymous client ID (solely used for counting the number of denials )
			function generateRandomClientId() {
				return Math.floor(Math.random() * 10000000000)
					.toString()
					.padStart(10, "0");
			}

			const unixTimestamp = Math.floor(Date.now() / 1000); // Current Unix timestamp
			const randomClientId = generateRandomClientId(); // Random 10-digit client ID

			const payload = {
				client_id: `${unixTimestamp}.${randomClientId}`,
				events: [
					{
						name: "Cookies_Declined",
						params: {
							engagement_time_msec: 1,
						}, // No additional information will be sent
					},
				],
			};

			fetch(
				`https://www.google-analytics.com/mp/collect?measurement_id=${measurementId}&api_secret=${apiSecret}`,
				{
					method: "POST",
					body: JSON.stringify(payload),
				}
			);

			//console.log(`https://www.google-analytics.com/debug/collect?measurement_id=${measurementId}&api_secret=${apiSecret}`);
			//console.log(JSON.stringify(payload));

			var cookie = "acceptCookie" + "=" + encodeURIComponent("declineCookie");

			cookie += "; max-age=" + 365 * 24 * 60 * 60;

			document.cookie = cookie;
			this.cookies = true;
		},
	},
	created() {
		this.getCookie("acceptCookie");
	},

	watch: {
		newList(val) {
			if (val) {
				this.$router.push({ path: `/${this.$i18n.locale}/list/` + val });
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  background: url("../../public/background.jpg") !important;
  min-height: 100vh; /* Change height to min-height */
  overflow-y: hidden; /* Change hidden to auto */
}

@media screen and (max-width: 576px) {
  .home {
    min-height: 100vh; /* Change height to min-height */
    overflow-y: auto; /* Explicitly set overflow to auto for mobile */
    padding-bottom: 13rem;
  }
}

.area {
  margin-top: 10%;
}
.cookies {
  background: rgba(190, 190, 190, 0.9);
  border-bottom: 1px solid rgba(190, 190, 190, 1);
  color: #fff;
  padding: 5px 15px;
  margin-top: 0rem;
}

.btn-accept {
  background-color: rgb(74, 160, 181);
  margin-left: 0rem;
  margin-top: 0.5rem;
}

.btn-policy {
  background-color: rgb(255, 255, 255);
  margin-left: 1rem;
  margin-top: 0.5rem;
}

.createB {
  width: 30%;
}

.pro-logo {
  height: 2.5rem;
  vertical-align: middle;
  margin-left: 0.25rem;
  margin-bottom: 0.2rem;
}

.pro-text {
  font-size: 1rem;
}

.navbar-fixed-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.container {
  margin-top: 2%;
}

.pro-suffix {
  font-size: 0.5em;
  vertical-align: sub; 
  margin-left: -1px;
}

@media screen and (max-width: 576px) {
  .show-screen {
    display: none;
  }
  .show-mobile {
    display: inline;
  }
}

@media screen and (min-width: 577px) {
  .show-mobile {
    display: none;
  }
}

@media (max-width: 365px) {
  .createB {
    width: auto; /* or width: initial; */
  }
}

.cookie-text {
  color: black;
}
.cookie-text button {
  margin-bottom: 3px;
}
.privacy-link {
  color: rgb(74, 160, 181); /* or any other color to indicate a link */
  text-decoration: underline; /* add underline to indicate it's clickable */
  cursor: pointer;
  font-weight: bold; /* change cursor to a hand pointer on hover */
}
.footer {
  position: absolute;
  bottom: -45rem;
  width: 100%;
  /*height: 60px; /* Set the fixed height of the footer here */
  line-height: 60px; /* Vertically center the text there */
  background-color: white;
  transition-timing-function: ease-out;
  transition: bottom 1s;
}

.button-div {
  position: absolute;
  bottom: 0px;
  left: 0px;
  transition: left 1s;
}
.toFaq {
  font-size: 3rem;
  position: absolute;
  bottom: 0.1rem;
  right: 0px;
}
.toFaq img {
  height: 3rem;
  opacity: 0.5;
  transition: height 0.1s;
}

.toFaq img:hover {
  height: 3.2rem;
  opacity: 1;
}

#dynamicFooter >>> h1 {
  font-size: 2rem;
}
#dynamicFooter >>> h2 {
  font-size: 1.2rem;
}
#dynamicFooter >>> p {
  font-size: 1rem;
  line-height: normal;
}
#social {
  font-size: 2rem;
  background-color: rgb(74, 160, 181);
}
#social a {
  margin-left: 1rem;
  margin-right: 1rem;
}
.row-close {
  margin-left: 0px;
}
.icon-social {
  height: 2.5rem;
}

@media screen and (max-width: 576px) {
  .home {
    height: 90vh;
  }
  .pro-button {
    font-size: 0.8rem;
  }
  .cookies {
    padding: 3px 2px;
    font-size: 12px;
  }
  .card {
    border: 2px solid #20cbf6;
    box-shadow: 17px 20px 33px -10px rgba(0, 0, 0, 0.2) !important;
    border-radius: 8px;
  }
  .area {
    margin-top: 20%;
  }
}
@media screen and (min-width: 577px) {
  .home {
    position: relative;
  }
}
</style>
